import type { Node } from "@xyflow/react";
import { isNodeLocked } from "./nodeLock";

export function mergeCanvasNodesMirror(
  nodes: Node[],
  prev: Node[] | undefined,
): Node[] {
  if (!prev?.length) return nodes;

  const prevById = new Map(prev.map((n) => [n.id, n]));
  return nodes.map((n) => {
    if (!n.dragging) return n;
    const cached = prevById.get(n.id);
    if (!cached) return n;
    return { ...n, position: cached.position };
  });
}

function nodeDataChanged(prev: Node, next: Node): boolean {
  if (prev.data === next.data) return false;
  try {
    return JSON.stringify(prev.data) !== JSON.stringify(next.data);
  } catch {
    return true;
  }
}

export function canvasNodesMirrorNeedsUpdate(
  next: Node[],
  prev: Node[] | undefined,
): boolean {
  if (!prev) return true;
  if (next.length !== prev.length) return true;

  const prevById = new Map(prev.map((n) => [n.id, n]));
  for (const n of next) {
    const p = prevById.get(n.id);
    if (!p) return true;
    if (p.parentId !== n.parentId) return true;
    if (p.type !== n.type) return true;
    if (p.hidden !== n.hidden) return true;
    if (isNodeLocked(p) !== isNodeLocked(n)) return true;
    if (nodeDataChanged(p, n)) return true;
    if (!n.dragging) {
      if (p.position.x !== n.position.x || p.position.y !== n.position.y) {
        return true;
      }
    }
  }
  return false;
}
